module.exports = __webpack_public_path__ + "img/logo.db9c4eb7.png";